export const API_ROOT = process.env.REACT_APP_API_URL;

export function get(endpoint, body, options) {
  return request('get', endpoint, body, options);
}

export function post(endpoint, body, options) {
  return request('post', endpoint, body, options);
}

export function put(endpoint, body, options) {
  return request('put', endpoint, body, options);
}

export function deleteReq(endpoint, options) {
  return request('delete', endpoint, null, options);
}

function request(method, endpoint, body = null, options = {}) {
  const fullUrl =
    endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;

  const token = localStorage.getItem('token');

  return fetch(fullUrl, {
    method: method,
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      ...options,
    },
    body,
  })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response);
      }

      return response;
    })
    .then(response => response.text())
    .then(data => (data ? JSON.parse(data) : {}))
    .catch(error => {
      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/services/api.js